// extracted by mini-css-extract-plugin
export var cartContainer = "_pu-4";
export var gray = "_pu-1";
export var itemContainer = "_pu-2";
export var itemDetails = "_pu-3";
export var strong = "_pu-0";